import styles from '../Overview/Overview.module.css'
import ExpensesPieChart from '../../components/Overview/ExpensesPieChart.js';
import MonthlyBarChart from '../../components/Overview/MonthlyBarChart';
import FilterBar from '../../components/FilterBar/FilterBar';
import SummaryStats from '../../components/Overview/SummaryStats/SummaryStats.js';
import CategoriesBreakdown from '../../components/Overview/CategoriesBreakdown/CategoriesBreakdown.js';
import { useOverviewData } from '../Overview/useOverviewData.js'
import { useUserId } from '../../hooks/useAuth';
import { PageHeader } from '../../components/PageHeader/PageHeader';

function Overview() {
  const userId = useUserId();
  
  const {
    displayCategories,
    totalIncome,
    totalExpenses,
    net,
    monthlyExpenses,
    selectedMonth,
    setSelectedMonth,
    selectedYear,
    setSelectedYear,
    categoriesLoading,
    transactionsLoading
  } = useOverviewData(userId);

  if (categoriesLoading || transactionsLoading) return <div className= "LoadingText"><h2>Loading Data...</h2></div>;

  return (
    <div>
      <PageHeader title= "Overview">
        <FilterBar
          selectedMonth={selectedMonth} 
          setSelectedMonth={setSelectedMonth} 
          selectedYear={selectedYear} 
          setSelectedYear={setSelectedYear}
        />
      </PageHeader>
      {displayCategories.length === 0 ? (
        <div className="NoDataDiv">
          <h2 className="NoDataMessage">There are no transactions for this time.</h2>
        </div>
      ) : (
        <div>
        <SummaryStats totalIncome={ totalIncome } totalExpenses={ totalExpenses } net={ net }/>
        <div className= {styles.graphsDiv}>
          <ExpensesPieChart data= { displayCategories }/>
          <MonthlyBarChart data= { monthlyExpenses }/>
        </div>
        <CategoriesBreakdown categories={ displayCategories }/>
      </div>
      )
      }
    </div>
  )
}

export default Overview;